import { render, staticRenderFns } from "./eventCategory.vue?vue&type=template&id=c2ec77ca&scoped=true&"
import script from "./eventCategory.vue?vue&type=script&lang=js&"
export * from "./eventCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ec77ca",
  null
  
)

export default component.exports